import { Navigate } from 'react-router-dom';

export const FrontendRoutes = {
  path: "/",
  children: [
    {
      path: "",
      element: <Navigate to="/auth/login" replace />,
    },
    {
      path: "*",
      element: <Navigate to="/auth/login" replace />,
    },
  ],
};